module.exports = __webpack_public_path__ + "static/MissionGrid-8639ce7f61f6808f4d86077c4307dca1.jpg";